module.exports = __webpack_public_path__ + "static/media/carousel6.b81ffecf.jpeg";